@if(orderedIngredient()){
    <fieldset class="ingredient-halves" [attr.aria-label]="'Pizza side selection'">
    <label>
        <input class="side-radio left" type="radio" [name]="radioGroupName()"
               [value]="sideSelectionType.LEFT" [checked]="value === sideSelectionType.LEFT"
               [disabled]="disableLeft()"
               [attr.aria-label]="sideSelectionType.LEFT + ' side only'"
               (click)="onOptionClick(sideSelectionType.LEFT, $event)">
    </label>
    <label>
        <input class="side-radio whole" type="radio" [name]="radioGroupName()"
               [value]="sideSelectionType.WHOLE"
               [checked]="value === sideSelectionType.WHOLE"
               [disabled]="disableWhole()"
               [attr.aria-label]="sideSelectionType.WHOLE + ' pizza'"
               (click)="onOptionClick(sideSelectionType.WHOLE, $event)">
    </label>
    <label>
        <input class="side-radio right" type="radio" [name]="radioGroupName()"
               [value]="sideSelectionType.RIGHT" [checked]="value === sideSelectionType.RIGHT"
               [disabled]="disableRight()"
               [attr.aria-label]="sideSelectionType.RIGHT + ' side only'"
               (click)="onOptionClick(sideSelectionType.RIGHT, $event)">
    </label>
</fieldset>
}
